var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFilledLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#44C941",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6662 6.87535L17.666 6.87535C17.5965 6.87809 17.5282 6.89623 17.467 6.92877C17.406 6.96118 17.3534 7.00722 17.3143 7.06383C17.3142 7.06409 17.314 7.06435 17.3138 7.06462L10.9326 16.0883L6.60767 12.5128C6.60766 12.5128 6.60765 12.5128 6.60764 12.5128C6.56446 12.477 6.5146 12.4499 6.4611 12.4324C6.40759 12.415 6.35112 12.4074 6.29479 12.4099C6.23847 12.4124 6.18294 12.425 6.13131 12.4473C6.07967 12.4696 6.03262 12.5012 5.99315 12.541C5.95367 12.5807 5.92251 12.6278 5.9021 12.6799C5.88167 12.732 5.87256 12.7876 5.87556 12.8435C5.87857 12.8993 5.89359 12.9537 5.91934 13.0034C5.94507 13.053 5.98086 13.0968 6.02407 13.1325L6.02409 13.1325L10.7286 17.0218L10.7286 17.0218C10.7763 17.0612 10.8321 17.0901 10.8919 17.1071C10.9517 17.1242 11.0145 17.1291 11.0763 17.1216C11.1381 17.1142 11.1979 17.0946 11.2516 17.0635C11.3053 17.0325 11.3519 16.9907 11.3876 16.9402C11.3876 16.9402 11.3876 16.9402 11.3876 16.9402L18.0483 7.52118C18.0485 7.52091 18.0487 7.52065 18.0488 7.52039C18.0948 7.45694 18.1215 7.38198 18.1247 7.30371C18.1278 7.22509 18.107 7.14795 18.0657 7.08099C18.0244 7.01418 17.9647 6.96061 17.8944 6.9249C17.8241 6.88922 17.7452 6.87231 17.6662 6.87535Z",
    fill: "#44C941",
    stroke: "#44C941",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFilledLight);
export default __webpack_public_path__ + "static/media/check-filled-light.d5619f33030b25b3113766aed7f4376c.svg";
export { ForwardRef as ReactComponent };